import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import {environment} from '../../environments/environment';
import {CryptoService} from './crypto.service';
import * as featureActions from '../my-features/index';
import { UpdateInfoModel } from '../my-features/updateInfo/update-info.model';
import { updateInfoType } from '../shareModel';

@Injectable({
  providedIn: 'root'
})
export class ProService {

  constructor(private store: Store<fromStore.State>, private http: HttpClient,
      private cryptoService: CryptoService) { }

  TranslateProDevice(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/device/transfer`, params);
  }

  ReadProPaymentSetting(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/setting/read`, params);
  }

  UpdateProPaymentSetting(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/setting/update`, params);
  }

  ReadProPaymentSettingByDistributor(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/setting/read/distributor`, params);
  }

  ReadProPaymentDocumentList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/document/list`, params);
  }

  ReadProPaymentDocument(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/document/read`, params);
  }

  UpdateProPaymentDocument(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/document/update`, params);
  }

  GenerateProPaymentDocument(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/document/add`, params);
  }

  ReadProDeviceUsageList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/device/usage/list`, params);
  }

  ReadProDeviceUsage(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/device/usage/read`, params);
  }

  CalculateProUpgradeNode(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/pro/upgrade/nodes`, params);
  }

  SendProUpgradeMail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/pro/upgrade/mail`, params);
  }

  CheckProUpgrade(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/pro/upgrade/check`, params);
  }

  ActivateProUpgrade(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/pro/upgrade/activate`, params);
  }

  SendProPaymentDocumentMail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/payment/document/send`, params);
  }

  ReadProNodes(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/pro/nodes/read`, params);
  }

  TransferProNodes(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/pro/nodes/transfer`, params);
  }

  AddProPaymentPay(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/pro/payment/pay`, params);
  }

  ActivatePayPalAgreement(params): Observable<any> {
    return this.http.post<any>(`/api/paypal/activate-agreement`, params);
  }

  AddProPaymentAgreement(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/pro/payment/agreement`, params);
  }
}
